module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\nconst toggle = model.toggle || {}\nconst toggleConfig = (fieldConfig.fields || {}).toggle || {}\nconst labels = model.labels || {}\nconst symbol = model.symbol || ''\n%><div><%\n%><div class=\"controls\"><%\n%><%- include('./toggle', { model: { dataINT: toggle.value, fieldCode: toggle.fieldCode, 'boolean-data': toggle.options, atom: { dataType: 'boolean' }, config: { ...toggleConfig, strict: true, singleButtonSwitch: true } }}) %><%\n%></div><%\n%><div class=\"labelContainer\"><%\nif(labels.ts){\n%><%- include('../elements/label', { model: { label: labels.ts, labelTitle: labels.ts }}) %><%\n}\nif(labels.entity){\n%><%- include('../elements/label', { model: { label: labels.entity, labelTitle: labels.entity }}) %><%\n}\n%></div><%\nif(symbol){\n%><div class=\"status\"><%\n%><i class=\"<%- symbol %>\"></i><%\n%></div><%\n}\n%></div>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\fields\\booleanFlagAndLabelsAndStatus.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}
const toggle = model.toggle || {}
const toggleConfig = (fieldConfig.fields || {}).toggle || {}
const labels = model.labels || {}
const symbol = model.symbol || ''

    ; __line = 7
    ; __append("<div>")
    ; 

    ; __line = 8
    ; __append("<div class=\"controls\">")
    ; 

    ; __line = 9
    ; __append( include('./toggle', { model: { dataINT: toggle.value, fieldCode: toggle.fieldCode, 'boolean-data': toggle.options, atom: { dataType: 'boolean' }, config: { ...toggleConfig, strict: true, singleButtonSwitch: true } }}) )
    ; 

    ; __line = 10
    ; __append("</div>")
    ; 

    ; __line = 11
    ; __append("<div class=\"labelContainer\">")
    ; 
if(labels.ts){

    ; __line = 13
    ; __append( include('../elements/label', { model: { label: labels.ts, labelTitle: labels.ts }}) )
    ; 
}
if(labels.entity){

    ; __line = 16
    ; __append( include('../elements/label', { model: { label: labels.entity, labelTitle: labels.entity }}) )
    ; 
}

    ; __line = 18
    ; __append("</div>")
    ; 
if(symbol){

    ; __line = 20
    ; __append("<div class=\"status\">")
    ; 

    ; __line = 21
    ; __append("<i class=\"")
    ; __append( symbol )
    ; __append("\"></i>")
    ; 

    ; __line = 22
    ; __append("</div>")
    ; 
}

    ; __line = 24
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\fields\booleanFlagAndLabelsAndStatus.ejs

}